<template>
  <div class="login">
    <div class="login__body">
      <div class="login__logo">
        <logo />
      </div>
      <h1>Авторизация</h1>
      <div class="login__form-group">
        <label class="login__form-group-label">Введите общий логин:</label>
        <Login />
        <input
          v-model="login.company"
          type="text"
          name="cm-tenant"
          autocomplete="organization"
          class="login__control"
        >
      </div>
      <div class="login__form-group">
        <label class="login__form-group-label">Введите логин:</label>
        <Login />
        <input
          v-model="login.user"
          type="text"
          name="cm-login"
          autocomplete="username"
          class="login__control"
        >
      </div>
      <div class="login__form-group login__form-group--password">
        <label class="login__form-group-label">Введите пароль:</label>
        <Password />
        <input
          v-model="login.password"
          name="password"
          autocomplete="current-password"
          class="login__control login__control--password"
          :type="showPassword ? 'text' : 'password'"
          @keyup="handleLogin"
        >
        <a
          class="login__eye"
          :class="showPassword ? 'login__eye--hide' : ''"
          @click.prevent="showPassword = !showPassword"
        >
          <Eye />
        </a>
      </div>
      <div
        v-if="error"
        class="login__error"
      >
        {{ error }}
      </div>
      <div class="login__controls">
        <vue-recaptcha
          v-if="hasRecaptcha"
          ref="recaptcha"
          size="invisible"
          language="ru"
          :sitekey="sitekey"
          :loadRecaptchaScript="hasRecaptcha"
          :recaptchaHost="recaptchaHost"
          @verify="register"
          @expired="onCaptchaExpired"
        />
        <Button
          skin="primary"
          :padding="40"
          class="login__button"
          :isLoading="loading"
          @click.native.prevent="handleLogin"
        >
          Войти
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/Icons/LogoCampaign.vue";
import Eye from "@/manzana_library/components/Icons/Eye";
import Login from "@/manzana_library/components/Icons/Login";
import Password from "@/manzana_library/components/Icons/Password";
import Button from "@/manzana_library/components/Elements/Button";

import VueRecaptcha from "vue-recaptcha";
import AuthenticationService from "@/services/AuthenticationService";

export default {
  name: "LoginPage2",

  components: {
    Logo,
    Eye,
    Login,
    Password,
    Button,
    VueRecaptcha,
  },

  data() {
    return {
      hasRecaptcha: true,
      recaptchaHost: "google.com",
      loading: false,
      login: {
        company: "",
        user: "",
        password: "",
      },
      showPassword: false,
      error: "",
      sitekey: "6Levw7QZAAAAABF-hlFbye5ZaoOT-knXu8CkAilL",
    };
  },

  created() {
    if (process.env.VUE_APP_USE_RECAPTCHA === 'true') this.hasRecaptcha = true;
    if (process.env.VUE_APP_USE_RECAPTCHA === 'false') this.hasRecaptcha = false;
    if (process.env.VUE_APP_RECAPTCHA_HOST) this.recaptchaHost = process.env.VUE_APP_RECAPTCHA_HOST;
  },

  methods: {
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    handleLogin(e) {
      if (e.type === "keyup" && e.keyCode !== 13) {
        return;
      }

      this.error = "";

      const { company, user, password } = this.login;
      if (!company || !user || !password) {
        this.error = "Не все поля заполнены.";
        return;
      }

      this.hasRecaptcha ? this.$refs.recaptcha.execute() : this.register(null);
    },
    async register(recaptcha) {
      // console.log("%c%s", "color:violet", recaptcha);
      try {
        this.loading = true;

        const { user, password, company } = this.login;
        const credentials = {
          Login: user,
          Password: password,
        };
        if (recaptcha) credentials.Recaptcha = recaptcha;
        const sessionData = await AuthenticationService.getToken(
          company,
          credentials,
        );

        this.$store.commit("SET_USER_INFO", {
          login: user,
          company,
          authTokenType: 'Bearer',
          ...sessionData.data,
        });

        if (this.$route.query.redirect)
          this.$router.push({ path: this.$route.query.redirect });
        else this.$router.push({ name: "home" });
      } catch (err) {
        console.warn("login error", err);
        this.error = "Неверное имя пользователя или пароль.";
        if (recaptcha) this.onCaptchaExpired();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$eye-width: 40px;

.login {
  display: flex;
  justify-content: center;
  align-self: center;
  background: $color_gray_3;
  @include size(100%, 100vh);

  &__body {
    background: $color_white;
    align-self: center;
    padding: ($gutter / 2) ($gutter / 1.25) $gutter;
    border-radius: $border-radius_base;
  }

  &__control {
    width: 412px;
    padding-left: $eye-width !important;

    &--password {
      width: calc(100% - #{$eye-width});
    }
  }

  &__form-group {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    margin-bottom: $gutter / 2;

    &-label {
      margin-bottom: $gutter / 4;
    }
  }

  &__eye {
    position: absolute;
    bottom: 13px;
    right: 7px;
    fill: $color_primary;
    cursor: pointer;
    @include size(20px, 14px);

    &--hide {
      fill: $color_active;
    }
  }

  &__logo {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;

    svg {
      height: 50px;
      width: 100%;
      margin: 0;
      padding: 15px 0 10px;
    }
  }

  &__error {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    color: $color_error;
    text-align: center;
  }

  &__controls {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__button {
    margin: 0;
    margin-top: 50px;
    margin-bottom: 50px;
  }

  &__link {
    font-size: 16px;
    color: $color_primary;
    text-decoration: underline;
  }

  .icon--login,
  .icon--password {
    position: absolute;
    left: 10px;
  }

  .icon--login {
    bottom: 10px;
  }

  .icon--password {
    bottom: 8px;
  }
}
</style>
